/** Misma lógica que Legalmente: `primary.main` sobre fondo verde oscuro en dark. */
export function readableHeading(theme) {
  return theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.primary.main;
}
